import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpHelper } from 'nglhelper';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet><loading-window *ngIf="showLoading"></loading-window><ng2-toasty position="top-center"></ng2-toasty>'
})
export class AppComponent {

  showLoading = false;
  constructor(private http: HttpHelper) {
    this.http.LoaderState('Global')
      .subscribe((res) => {
        this.showLoading = res;
      });
  }
}
